var DropDown = require('../../../../common/dropDown/dropDownWr'),
    DropDownContent = require('../../../../common/dropDown/dropDownContentView'),
    $ = require('jquery');

/*
 a mix of DD content and Base -- content for el to refer to the list, Base Used for ddOptions to capture onSelect Menu Events
*/

module.exports = DropDownContent.extend({
    template: require('./zoomDD.hbs'),
    ddDefaults: DropDown.prototype.ddDefaults, /* Allow Menu Selection */
    templateOptions: function() {
        var mode = this.model.get('mode');
        return {
            mode: mode,
            scaleValues: this.options.vChannel.request((mode==='page' ? 'page': 'doc') + 'ModeScaleValues')
        };
    },
    onRender: function() {
        this.model.get('mode') === 'page' && this.$('[data-scale="Fit Height"]').after($('<div>').addClass('divider'));
    },
    //todo: ui and clean
    defaultSelector: function() {
        return '[data-scale="' + this.model.get('DEFAULT_SCALE') + '"]';
    },
    onChange: function(selectedValue, selectedData) {
        var newScale = selectedData.scale,
            newScaleType = !newScale
                ? 'custom'
                : isNaN(newScale) ? newScale : 'predefined';
        this.options.vChannel.command('setScale', newScale, newScaleType);
    },
    updatePostScale: function(scaleModel, scaleVal) { //should be a model change...
        var friendlyScaleValue = scaleModel.getFriendlyScaleValue(),//TODO: VARIABLE
            $ddMenu = this.getDDContent();
        //remove prior added custom mi if added regardless of type
        if (this.$customMi) {
            this.$customMi.remove();
            delete this.$customMi;
        }
        if (scaleModel.get('scaleType') === 'custom') {
            $ddMenu.find('.mi.active').removeClass('active');

            this.dropdown.find('.ddValue').text(friendlyScaleValue); /* note: this.dropdown refers to the opener */

            //todo:  put in order,  could make from template partial
            this.$customMi = $('<div class="mi active" data-scale="' + parseFloat(scaleVal) + '">' + friendlyScaleValue + '</div>').appendTo($ddMenu);

        }
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerCenter/zoom/zoomDD.js
 ** module id = 721
 ** module chunks = 0
 **/